module.exports = __webpack_public_path__ + "static/open-doors-5a343c324bae169d38b2a82fafc1b6f4.jpg";